import { render, staticRenderFns } from "./CourseFinder.vue?vue&type=template&id=1657b573&scoped=true"
import script from "./CourseFinder.vue?vue&type=script&lang=js"
export * from "./CourseFinder.vue?vue&type=script&lang=js"
import style0 from "./CourseFinder.vue?vue&type=style&index=0&id=1657b573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1657b573",
  null
  
)

export default component.exports